import { Array, Boolean, Null, Number, Record, Static, String } from "runtypes";

const ResponseSummaryRequestBaseRuntype = Record({
  coachId: Number,
  summary: String,
  surveyQuestionId: Number,
});

export interface IResponseSummaryBase
  extends Static<typeof ResponseSummaryRequestBaseRuntype> {}

export const ResponseSummaryRequestRuntype = Record({
  schoolId: Number,
  summaries: Array(
    Record({
      coachId: Number,
      parentSummary: String.Or(Null),
      studentSummary: String,
      studentComments: Array(String),
      studentCommentsEdited: Boolean,
      surveyQuestionId: Number,
    })
  ),
});

export interface IResponseSummaryRequest
  extends Static<typeof ResponseSummaryRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/services/IResponseSummaryRequest.ts